import { DragOverlay } from '@dnd-kit/core';
import React from 'react';
import { Module } from '../DraggableModules/ModulesContainer/DraggableModule/Module/Module';
import type { ServerModule } from '../ServerWorkflowType';
import styles from './DragOverlayModule.module.scss';

interface DragOverlayModuleProperties {
  activeModule: ServerModule | null;
}

const DragOverlayModule: React.FC<DragOverlayModuleProperties> = ({
  activeModule,
}) => {
  return (
    <DragOverlay>
      {activeModule ? (
        <div className={styles.overlayModule}>
          <Module module={activeModule} />
        </div>
      ) : null}
    </DragOverlay>
  );
};

export default DragOverlayModule;
